/**
 * Auth session utilities — handles token validation, expiry detection, and tab-focus checks.
 */

// Decode JWT payload without a library
function decodeToken(token) {
  try {
    const payload = token.split('.')[1];
    return JSON.parse(atob(payload));
  } catch {
    return null;
  }
}

// Check if token is valid and not expired
export function isTokenValid() {
  const token = localStorage.getItem('authToken');
  if (!token) return false;
  
  const decoded = decodeToken(token);
  if (!decoded) return false;
  
  // Check expiry (JWT exp is in seconds)
  if (decoded.exp && decoded.exp * 1000 < Date.now()) {
    clearSession();
    return false;
  }
  
  return true;
}

// Clear all session data
export function clearSession() {
  localStorage.removeItem('authToken');
  localStorage.removeItem('user');
  localStorage.removeItem('userId');
  localStorage.removeItem('user_permissions');
}

// Install tab-focus listener — redirects to login when user switches back to a tab with an expired token
let listenerInstalled = false;

export function installAuthInterceptor() {
  if (listenerInstalled) return;
  listenerInstalled = true;

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      const path = window.location.pathname;
      if (path === '/login' || path === '/client/login' || path.includes('forgot-password') || path.includes('reset-password') || path === '/') return;
      if (!isTokenValid()) {
        const loginPath = path.startsWith('/client') ? '/client/login' : '/login';
        window.location.href = loginPath;
      }
    }
  });
}
